export default __webpack_public_path__ + "static/media/db.8a5842f9.svg";